import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate } from "@/lib/util";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-logs", { params: { limit: 500 } }).then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1400px]">
      <header className="mb-6">
        <div className="overline">Compliance</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tighter mt-1">Audit log</h1>
        <p className="text-sm text-muted-foreground mt-1">Immutable record of every action taken in PayTrack.</p>
      </header>
      {/* Mobile card list */}
      <div className="md:hidden space-y-3" data-testid="audit-mobile-list">
        {rows.map((r) => (
          <div key={r.id} data-testid={`audit-card-${r.id}`} className="glass rounded-2xl p-4 shimmer-border">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="min-w-0">
                <div className="font-mono text-xs text-amber-700 font-bold truncate">{r.action}</div>
                <div className="text-[10px] text-slate-500 font-mono mt-0.5">{fmtDate(r.at)}</div>
              </div>
              {r.actor_role && (
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-wider bg-slate-100 border border-slate-200 text-slate-700 shrink-0">
                  {r.actor_role}
                </span>
              )}
            </div>
            <div className="text-xs text-slate-700 mb-1 truncate">{r.actor_email || "—"}</div>
            <div className="flex items-center gap-2 text-[11px] text-slate-500 mb-2 flex-wrap">
              <span>{r.entity_type}</span>
              {r.entity_id && <span className="font-mono">{r.entity_id.slice(-6)}</span>}
              {r.ip && <span className="font-mono ml-auto">{r.ip}</span>}
            </div>
            {r.detail && (
              <div className="font-mono text-[10px] text-slate-500 bg-white/60 border border-white/70 rounded-lg px-2 py-1.5 break-all line-clamp-3">
                {JSON.stringify(r.detail)}
              </div>
            )}
          </div>
        ))}
        {rows.length === 0 && (
          <div className="glass rounded-2xl p-8 text-center text-sm text-slate-500">No activity yet.</div>
        )}
      </div>

      {/* Desktop table */}
      <div className="hidden md:block border border-border bg-white overflow-x-auto">
        <table className="w-full ledger-table text-sm">
          <thead className="bg-gray-50"><tr className="text-left">
            {["When","Actor","Role","Action","Entity","IP","Detail"].map((h) => <th key={h} className="px-4 py-2 overline">{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`audit-row-${r.id}`}>
                <td className="px-4 py-3 text-xs font-mono">{fmtDate(r.at)}</td>
                <td className="px-4 py-3">{r.actor_email || "—"}</td>
                <td className="px-4 py-3 uppercase text-xs">{r.actor_role || "—"}</td>
                <td className="px-4 py-3 font-mono text-xs">{r.action}</td>
                <td className="px-4 py-3 text-xs">{r.entity_type} <span className="font-mono text-muted-foreground">{r.entity_id?.slice(-6)}</span></td>
                <td className="px-4 py-3 font-mono text-xs">{r.ip || "—"}</td>
                <td className="px-4 py-3 font-mono text-xs text-muted-foreground max-w-md truncate">{r.detail ? JSON.stringify(r.detail) : "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-sm text-muted-foreground">No activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
